var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subheader-item",on:{"click":_vm.goTo}},[_c('p',{staticClass:"subheader-item__text",class:{
            'subheader-item__text--active': _vm.isActive,
        },attrs:{"data-cy":"subheader-item-label"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.isActive)?_c('div',{staticClass:"subheader-item__bar-active",attrs:{"data-cy":"subheader-item-bar-active"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }